var render = function render(){var _vm=this,_c=_vm._self._c;return _c('liste-documents',{attrs:{"categorie":_vm.categorie,"title":_vm.$t('menu.documents.resultatsAnalyses')}})
}
var staticRenderFns = []

export { render, staticRenderFns }